import React, { useState } from 'react'
import RolesForm from './RolesForm';
import RolesListview from './RolesListview';

const Roles = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <RolesForm addForm={setFromIsShown} update={upData} />
        ) : (
          <RolesListview addForm={setFromIsShown} update={setUpData} />
        )}
  
    </>
  )
}

export default Roles